import { Alert, Box, Grid, Paper, Snackbar, Typography } from "@mui/material";
import axios from "axios";
import React from "react";
import { useNavigate } from "react-router";
import {useCookies} from "react-cookie";
import {
  CssButton,
  CssTextField,
} from "../../NewProjectView/components/StyledComponent";

const RegisterPage = () => {
  const navigate = useNavigate();
  const [openError, setOpenError] = React.useState(false);
  const [msgError, setMsgError] = React.useState("");
  const [values, setValues] = React.useState({
    email: "",
    password: "",
  });
  const [cookie, setCookie] = useCookies([])

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        "https://nft-carbon-server.herokuapp.com/api/register",
        {
          ...values,
        },
        {
          withCredentials: true,
        }
      );
      if (data) {
        if (data.errors) {
          const { email, password } = data.errors;
          if (email) {
            setOpenError(true);
            setMsgError(email);
          } else if (password) {
            setOpenError(true);
            setMsgError(password);
          }
        } else {
          setCookie('jwt', data.token, { path: '/', maxAge: (1*24*60*60*1000)})
          console.log(cookie)
          navigate("/");
        }
      }
    } catch (error) {
      throw Error(error);
    }
  };
  const handleCloseError = () => {
    setOpenError(false);
  };

  return (
    <form onSubmit={handleSubmit}>
    <Grid
      container
      direction="row"
      justifyContent="center"
      sx={{
        backgroundColor: "#46bda7",
        height: "calc(100vh - 64px)",
        padding: 5,
      }}
    >
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={handleCloseError}
      >
        <Alert
          onClose={handleCloseError}
          severity="error"
          sx={{ width: "100%" }}
        >
          {msgError}
        </Alert>
      </Snackbar>
      <Grid item xs={6}>
        <Paper sx={{ borderRadius: 4, padding: 3, textAlign: "center" }}>
          <Typography
            variant="h5"
            color="secondary"
            sx={{ fontWeight: "bolder" }}
          >
            Bienvenue
          </Typography>
          <Typography
            color="secondary"
            sx={{ fontWeight: "lighter", padding: 2 }}
          >
            Rejoignez notre communauté d’investisseurs pour accéder à nos
            analyses détaillées et recevoir nos dernières opportunités
            d’investissement.
          </Typography>
          <Box marginTop={3}>
            <CssTextField helperText=" " label="Votre prenom" size="small" />
          </Box>
          <Box>
            <CssTextField helperText=" " label="Votre nom" size="small" />
          </Box>
          <Box>
            <CssTextField
              helperText=" "
              name="email"
              label="Votre email"
              size="small"
              type="email"
              required={true}
              onChange={(e) =>
                setValues({ ...values, [e.target.name]: e.target.value })
              }
            />
          </Box>
          <Box>
            <CssTextField
              helperText=" "
              label="Votre mot de passe"
              size="small"
              name="password"
              type="password"
              required={true}
              onChange={(e) =>
                setValues({ ...values, [e.target.name]: e.target.value })
              }
            />
          </Box>
          <Box marginTop={3}>
            <CssButton variant="contained" type="submit">
              S'inscrire
            </CssButton>
          </Box>
        </Paper>
      </Grid>
    </Grid>
    </form>
  );
};

export default RegisterPage;
